// Perfil criado: o cadastro vai ao GA4 (sign_up) e ao painel (cadastro_origem) com a origem do link, se houver.
import { tirarOrigem } from './chegada.ts';
import { conta, type Sessao } from './conta.ts';
import { medir } from './medicao.ts';

export function cadastrou(s: Sessao): void {
  const o = tirarOrigem();
  medir('sign_up', { method: 'google', ...(o ? { origem: o.origem, cta: o.cta ?? '(sem cta)' } : {}) });
  if (o) void conta.registrarOrigem(s, o).catch(() => {}); // evento do painel: se falhar, o cadastro segue
}
